var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{class:'text-center'+' '+
      (typeof _vm.fullWidth==='undefined' ? 'd-inline-block' : '')+' '+
      (typeof _vm.small==='undefined' ? 'body-2 px-2 py-1' : 'caption px-1')+' '+
      (typeof _vm.clickable==='undefined' ? '' : 'clickable')+' '+
      'align-center',attrs:{"width":typeof _vm.fullWidth==='undefined' ? '' : '100%',"dark":typeof _vm.dark!=='undefined',"rounded":"","color":typeof _vm.color==='undefined' ? 'grey lighten-4' : _vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }